module.exports = __webpack_public_path__ + "static/img/3.cfbe1c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/sp/3.png
// module id = iuWl
// module chunks = 0